<template>
  <form-item v-bind="$attrs" v-on="$listeners">
    <el-input v-if="number" oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model.number="model[$attrs.prop][0]"></el-input>
    <el-input v-else v-model="model[$attrs.prop][0]"></el-input>
    <el-input style="margin-left: 10px" v-if="number" oninput="value=value.replace(/[0-9.]/g,'')"
              v-model.number="model[$attrs.prop][1]"></el-input>
    <el-input style="margin-left: 10px" v-else v-model="model[$attrs.prop][1]"></el-input>
  </form-item>
</template>

<script>
  import FormItem from '@/components/form/FormItem'

  export default {
    name: 'Input2FormItem',
    components: { FormItem },
    props: {
      number: Boolean
    },
    computed: {
      model () {
        let parent = this.$parent
        while (parent) {
          if (parent.model != null) return parent.model
          parent = parent.$parent
        }
        return null
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    .el-input {
      width: 80px;
    }

    .el-input__inner {
      padding: 0 8px;
    }

    .el-input__inner {
      border-color: #DCDFE6 !important;
    }

    .el-input__inner:hover {
      border-color: darkgrey !important;
    }

    .el-input__inner:focus {
      border-color: #1890ff !important;
    }
  }
</style>
